var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp2StickerOnWallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.d{fill:none;}.b{fill:#efefef;}.c,.d{stroke:#e5e5e5;}.c,.d,.f{stroke-linecap:round;}.c,.d,.f,.g,.h{stroke-linejoin:round;stroke-width:2px;}.d,.e,.f,.g,.h{fill-rule:evenodd;}.e,.g{fill:#3c3c46;opacity:0.15;}.f{fill:#89d9fb;}.f,.g,.h{stroke:#3c3c46;}.h{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-sticker-on-wall-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 91.67,
    y: 5,
    width: 43.33,
    height: 18.57
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 26.67,
    y: 23.57,
    width: 43.33,
    height: 18.57
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 5,
    y: 60.71,
    width: 21.67,
    height: 18.57
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 70,
    y: 60.71,
    width: 43.33,
    height: 18.57
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 26.67,
    y: 97.86,
    width: 43.33,
    height: 18.57
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 91.67,
    y: 116.43,
    width: 43.33,
    height: 18.57
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 116.43,
    x2: 5,
    y2: 116.43
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 48.33,
    y1: 116.43,
    x2: 48.33,
    y2: 135
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 91.67,
    y1: 116.43,
    x2: 91.67,
    y2: 135
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 116.43,
    x2: 135,
    y2: 135
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5,
    y1: 116.43,
    x2: 5,
    y2: 135
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 70,
    y1: 97.86,
    x2: 70,
    y2: 116.43
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 113.33,
    y1: 97.86,
    x2: 113.33,
    y2: 116.43
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 26.67,
    y1: 97.86,
    x2: 26.67,
    y2: 116.43
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 97.86,
    x2: 5,
    y2: 97.86
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5,
    y1: 97.86,
    x2: 5,
    y2: 116.43
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 48.33,
    y1: 79.29,
    x2: 48.33,
    y2: 97.86
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 91.67,
    y1: 79.29,
    x2: 91.67,
    y2: 97.86
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 79.29,
    x2: 135,
    y2: 97.86
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5,
    y1: 79.29,
    x2: 5,
    y2: 97.86
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 70,
    y1: 60.71,
    x2: 70,
    y2: 79.29
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 113.33,
    y1: 60.71,
    x2: 113.33,
    y2: 79.29
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 26.67,
    y1: 60.71,
    x2: 26.67,
    y2: 79.29
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 60.71,
    x2: 5,
    y2: 60.71
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5,
    y1: 60.71,
    x2: 5,
    y2: 79.29
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 42.14,
    x2: 5,
    y2: 42.14
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 48.33,
    y1: 42.14,
    x2: 48.33,
    y2: 60.71
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 91.67,
    y1: 42.14,
    x2: 91.67,
    y2: 60.71
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 42.14,
    x2: 135,
    y2: 60.71
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5,
    y1: 42.14,
    x2: 5,
    y2: 60.71
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 70,
    y1: 23.57,
    x2: 70,
    y2: 42.14
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 113.33,
    y1: 23.57,
    x2: 113.33,
    y2: 42.14
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 26.67,
    y1: 23.57,
    x2: 26.67,
    y2: 42.14
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 23.57,
    x2: 5,
    y2: 23.57
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5,
    y1: 23.57,
    x2: 5,
    y2: 42.14
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 60.68,
    y1: 5,
    x2: 5,
    y2: 5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 48.33,
    y1: 5,
    x2: 48.33,
    y2: 23.57
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 91.67,
    y1: 5,
    x2: 91.67,
    y2: 23.57
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 5,
    x2: 135,
    y2: 23.57
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5,
    y1: 5,
    x2: 5,
    y2: 23.57
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 97.86,
    x2: 135,
    y2: 116.43
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 60.71,
    x2: 135,
    y2: 79.29
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 23.57,
    x2: 135,
    y2: 42.14
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 5,
    x2: 79.32,
    y2: 5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 73.32,
    y1: 5,
    x2: 66.68,
    y2: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M105.51,135H5m130,0H124.15m-6,0h-6.64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M31.53,79.29H5m130,0H44.16m-5,0H36.52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M96.17,56.59l-6.24,6.24a17.36,17.36,0,1,0,0,24.54l19.57,19.57A45,45,0,1,1,70.26,30.68Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M95,51,88.8,57.28a17.36,17.36,0,1,0,0,24.54l19.57,19.57A45,45,0,1,1,69.13,25.13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M68.53,47.45c0,12.44,5,20.86,13.19,24.42L94.95,51.19,95,51,69.13,39.71v.06A51.81,51.81,0,0,0,68.53,47.45Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M68.53,32.53A44.89,44.89,0,0,0,81.72,64.37L94.95,51.13,95,51,69.13,25.13v.05A45.33,45.33,0,0,0,68.53,32.53Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp2StickerOnWallIcon);
export default __webpack_public_path__ + "static/media/CP2-sticker-on-wall-icon.520341c12644834086e7896b061dc5c5.svg";
export { ForwardRef as ReactComponent };